import { useNavigate } from 'react-router-dom'
import useForm from '@/hooks/useForm'
import { AddDoctor, uploadFile } from '@/api/endpoints'
import { usePost } from '@/api/hooks'

const useCreateDoctor = () => {
    const navigate = useNavigate()
    const { formHandler, onSubmit } = useForm()
    const { handleFormValues } = formHandler
    const { onPost, isLoading: isSubmitting } = usePost(AddDoctor)


    const handleProfileImageChange = (file) => {
        handleFormValues('image', { value: file, isRequired: false, isError: false })
    }

    const handleDocumentsChange = (files) => {
        const fileArray = Array.isArray(files) ? files : Array.from(files)
        handleFormValues('documents', { value: fileArray, isRequired: false, isError: false })
    }

    const removeDocument = (index) => {
        const updatedDocuments = documents.filter((_, i) => i !== index)
        handleFormValues('documents', { value: updatedDocuments, isRequired: false, isError: false })
    }

    const handleSubmit = () => {

        const formData = new FormData()

        formHandler?.formValues?.image?.value.forEach(element =>
            formData.append('doctorImg', element));


        formHandler?.formValues?.documents?.value.forEach(element =>
            formData.append('doctorAttachments', element));


        uploadFile(formData).then(response => {
            let DataObject = {
                name: formHandler?.formValues?.doctorName?.value,
                nameEn: formHandler?.formValues?.doctorNameEn?.value,
                email: formHandler?.formValues?.email?.value,
                phoneNumber: formHandler?.formValues?.phoneNumber?.value,
                bio: formHandler?.formValues?.bio?.value,
                bioEn: formHandler?.formValues?.bioEn?.value,
                birthDate: formHandler?.formValues?.birthDate?.value,
                providerId: formHandler?.formValues?.providerId?.value,
                specialtyId: formHandler?.formValues?.specialty?.value?.value,
                majorSpecialtyId: formHandler?.formValues?.department?.value?.value,
                attachmentsIds: response.data,
            }
            onSubmit((d) => {
                onPost(DataObject)
            })
        }).catch(error => {
            console.log(error)
        })
    }

    const navToDoctorReport = () =>
        navigate('/panel/provider/doctors')


    const resetForm = () => {
        setProfileImage(null)
        setDocuments([])
    }

    return {
        // State
        isLoading: isSubmitting,
        profileImage: formHandler?.formValues?.image?.value || [],
        documents: formHandler?.formValues?.documents?.value || [],
        formHandler,

        // Handlers
        handleProfileImageChange,
        handleDocumentsChange,
        removeDocument,
        handleSubmit,
        navToDoctorReport,
        resetForm,

        // Utilities
        navigate
    }
}

export default useCreateDoctor

